import { ReactNode } from "react";

import { cn } from "@bentolabs/kit/utils";

import { Dialog } from "shared/ui/dialog";

type Props = {
  img: ReactNode;
  title: string;
  className?: string;
};

export const Header = (props: Props) => {
  const { img, title, className } = props;
  return (
    <Dialog.Title
      showClose
      className={cn("flex gap-4.5 bg-white/5 p-4.5", className)}
    >
      <div className="flex size-9.5 rounded-xl bg-current p-1.5">{img}</div>
      <h2 className="text-white">{title}</h2>
    </Dialog.Title>
  );
};
